module.exports = __webpack_public_path__ + "media/images/front/hospitals/fukuoka_sanno-d8731e7aa7e398275b71f3854e034f87.jpg";